<template>
  <div v-if="visible" class="popup-block">
    <div class="form-popup-default">
      <v-card>
        <v-btn
          class="close-button"
          title="Отменить"
          variant="text"
          text
          @click="$emit('cancel')"
        >
          <v-icon>ti-close</v-icon>
        </v-btn>

        <div>
          <v-card-title>{{ title }}</v-card-title>

          <v-card-text>
            <v-form>
              <v-container>
                <v-row>
                  <label class="pd-lr-10 mb-4 pr-7 pl-7 text-center">
                    {{ text }}
                  </label>

                  <div
                    class="text-center confirm-dialog-actions"
                    :class="{ 'confirm-dialog-actions--stacked': secondaryConfirmLabel }"
                  >
                    <v-btn
                      v-if="!secondaryConfirmLabel"
                      class="btnSave mr-4 primary-btn"
                      @click="$emit('confirm')"
                    >
                      {{ confirmLabel }}
                    </v-btn>

                    <v-btn
                      v-if="!secondaryConfirmLabel"
                      class="btnSave btnClose"
                      color="default"
                      @click="$emit('cancel')"
                    >
                      {{ cancelLabel }}
                    </v-btn>

                    <v-btn
                      v-if="secondaryConfirmLabel"
                      class="btnSave primary-btn confirm-dialog-action"
                      @click="$emit('confirm')"
                    >
                      {{ confirmLabel }}
                    </v-btn>

                    <v-btn
                      v-if="secondaryConfirmLabel"
                      class="btnSave primary-btn confirm-dialog-action"
                      @click="$emit('secondary-confirm')"
                    >
                      {{ secondaryConfirmLabel }}
                    </v-btn>
                  </div>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Подтвердите действие"
    },
    text: {
      type: String,
      required: true
    },
    confirmLabel: {
      type: String,
      default: "ОК"
    },
    cancelLabel: {
      type: String,
      default: "Отмена"
    },
    secondaryConfirmLabel: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped>
.confirm-dialog-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.confirm-dialog-actions--stacked .confirm-dialog-action {
  height: auto !important;
  min-height: 38px;
  width: 100%;
  padding: 8px 16px;
  white-space: normal;
}
</style>
